import AppleIcon from '@mui/icons-material/Apple';
import { Button, Typography } from '@mui/material';
import config from 'config';
import { useTranslation } from 'react-i18next';
import useStylesQrConfirmation from './styles/useStylesQrConfirmation.style';

const GooglePlayIcon = ({ className }) => (
    <svg className={className} viewBox="0 0 64 64" aria-hidden="true" focusable="false">
        <path d="M9.6 5.8c-1.2.7-2 2.2-2 4.4v43.6c0 2.2.8 3.7 2 4.4L35.2 32 9.6 5.8z" fill="#34a853" />
        <path d="M35.2 32 9.6 58.2c1.5.9 3.5.7 5.7-.6l30.5-17.4L35.2 32z" fill="#4285f4" />
        <path d="m45.8 23.8-30.5-17.4c-2.2-1.3-4.2-1.5-5.7-.6L35.2 32l10.6-8.2z" fill="#fbbc04" />
        <path d="m56.1 29.7-10.3-5.9L35.2 32l10.6 8.2 10.3-5.9c2.9-1.6 2.9-3 0-4.6z" fill="#ea4335" />
    </svg>
);

const QrConfirmation = () => {
    const { t } = useTranslation();
    const { classes } = useStylesQrConfirmation();
    const iconUrl = config.agentsApp.iconUrl;
    const storeLinks = [
        {
            href: config.agentsApp.iosStoreUrl,
            icon: <AppleIcon className={classes.appleIcon} />,
            eyebrow: 'Download on the',
            label: 'App Store',
            ariaLabel: 'Download Onlive Agents on the App Store',
        },
        {
            href: config.agentsApp.androidStoreUrl,
            icon: <GooglePlayIcon className={classes.googlePlayIcon} />,
            eyebrow: 'GET IT ON',
            label: 'Google Play',
            ariaLabel: 'Get Onlive Agents on Google Play',
        },
    ].filter((store) => store.href);

    return (
        <div className={classes.root}>
            <div className={classes.card}>
                <img src={iconUrl} alt={t('qrConfirmation.title')} className={classes.icon} />
                <Typography variant="h4" component="h1" className={classes.title}>
                    {t('qrConfirmation.title')}
                </Typography>
                <Typography variant="subtitle1" className={classes.description}>
                    {t('qrConfirmation.description')}
                </Typography>
                <div className={classes.storeButtons}>
                    {storeLinks.map((store) => (
                        <Button
                            key={store.label}
                            component="a"
                            href={store.href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.storeButton}
                            aria-label={store.ariaLabel}
                            disableRipple
                        >
                            {store.icon}
                            <span className={classes.storeText}>
                                <span className={classes.storeEyebrow}>{store.eyebrow}</span>
                                <span className={classes.storeLabel}>{store.label}</span>
                            </span>
                        </Button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default QrConfirmation;
